import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import {
  changeDate,
  changeFilter,
  IChangeDatePayload,
  IChangeFilterPayload,
  ISearchPayload,
  ISetCountryFilterPayload,
  search,
  searchRequest,
  setCountry
} from 'store/modules/events/actions';
import { IEventsState as IReduxState } from 'store/modules/events/reducer';
import { ActionProp } from 'types/actions';
import { RootState } from 'types/store';

const mapStateToProps = (state: RootState) => ({
  events: state.events
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      changeDate,
      changeFilter,
      search,
      searchRequest,
      setCountry
    },
    dispatch
  );

interface IEventsState {
  events: IReduxState;
}

interface IEventsDispatch {
  changeDate: ActionProp<IChangeDatePayload>;
  changeFilter: ActionProp<IChangeFilterPayload>;
  searchRequest: ActionProp<ISearchPayload>;
  search: ActionProp<ISearchPayload>;
  setCountry: ActionProp<ISetCountryFilterPayload>;
}

export type WithEventsProps = IEventsDispatch & IEventsState;

const withEventsState = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withEventsState;



// WEBPACK FOOTER //
// ./src/enhancers/withEventsState.tsx